import React from "react";
import { Link } from "react-router-dom";

const SIZES = {
  sm: { img: "w-7 h-7", text: "text-sm" },
  md: { img: "w-10 h-10", text: "text-lg" },
  lg: { img: "w-12 h-12", text: "text-xl" },
};

export const BrandShield = ({ className = "w-10 h-10" }) => (
  <img src="/ezguard-shield.png" alt="EZGuard shield" className={`brand-shield ${className} object-contain shrink-0`} data-testid="brand-shield" />
);

export default function BrandLogo({ size = "md", subtitle = "Family vault", testid = "brand-logo" }) {
  const s = SIZES[size];
  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <BrandShield className={s.img} />
      <div>
        <div className={`font-[Outfit] font-bold leading-tight tracking-tight ${s.text}`}>
          <span className="text-silver-gradient">EZ</span>
          <span className="text-brand-gradient">Guard</span>
        </div>
        {subtitle && (
          <div className="text-[10px] uppercase tracking-[0.1em] text-[color:var(--vault-text-tertiary)]">{subtitle}</div>
        )}
      </div>
    </div>
  );
}

export const BrandHomeLink = ({ linkTestid, ...logoProps }) => {
  const goToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <Link
      to="/"
      onClick={goToTop}
      aria-label="EZGuard home"
      className="inline-flex focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--vault-brand)] focus-visible:ring-offset-2"
      data-testid={linkTestid}
    >
      <BrandLogo {...logoProps} />
    </Link>
  );
};
